import React from 'react';
import { Departments } from '../components';

export default () => {
    return (
        <Departments.Home />
    )
}